// Splits the public statistics overview rows: all-time headline figures keep every
// originator (investors' historical totals must not shrink), while the doughnut and
// per-status sums cover only currently active ones.

// Only an explicit inactive flag hides a row. Anything this does not recognise stays
// visible and is reported: silently losing an originator from the public page is the
// one outcome that must not happen.
export function isActiveRow(overview)
{
  const flag = overview.lo_active
  if (flag === undefined || flag === null || flag === true || flag === 1 || flag === '1')
  {
    return true
  }
  if (flag === false || flag === 0 || flag === '0')
  {
    return false
  }
  console.error('Unexpected lo_active value, keeping the originator visible:', flag)
  return true
}

const toInt = value =>
{
  const parsed = parseInt(value)
  if (isNaN(parsed))
  {
    console.error('Statistics overview row carries a non-numeric value:', value)
    return 0
  }
  return parsed
}

export function splitOverviewSums(rows)
{
  const activeRows = rows.filter(isActiveRow)
  const sums = {
    loansFundedSum: 0,
    totalPaidToInvestorsSum: 0,
    loStatsSum: 0,
    statusesSum: {current: 0, dpd1_30: 0, dpd31_60: 0, buyback_initiated: 0},
    activeRows: activeRows
  }
  rows.forEach(row =>
  {
    sums.loansFundedSum += toInt(row.invested_on_platform_all_time)
    sums.totalPaidToInvestorsSum += toInt(row.total_paid_to_investors)
  })
  activeRows.forEach(row =>
  {
    sums.loStatsSum += toInt(row.outstanding_to_investors)
    sums.statusesSum.buyback_initiated += toInt(row.buyback_initiated)
    sums.statusesSum.current += toInt(row.current)
    sums.statusesSum.dpd1_30 += toInt(row.dpd1_30)
    sums.statusesSum.dpd31_60 += toInt(row.dpd31_60)
  })
  return sums
}
